<template>
  <div class="p-content-title">
    <h1 class="p-content-title__title f-title-32 t-fg-primary">{{ title }}</h1>

    <div v-if="date || readingTime" class="p-content-title__subtitle">
      <div v-if="formattedDate" class="f-utility-14 t-fg-tertiary">{{ formattedDate }}</div>
      <div v-if="readingTime" class="f-utility-14 t-fg-tertiary">
        {{ $t('x.xMinuteReadingTime', { x: readingTime }) }}
      </div>
    </div>

    <div v-if="socialIcons && 0 < socialIcons.length" class="p-content-title__social">
      <div v-for="icon in socialIcons" :key="icon">
        <p-icon
          :icon="`share-${icon}`"
          size="sm"
          color="fg-primary"
          class="cursor-pointer"
          @click="handleShare(icon)"
        />

        <div v-if="copied && icon === 'link'" class="p-content-title__social-copied">
          {{ $t('general.copied') }}!
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useShare } from '@/composables/useShare'
const copied = ref(false)

const props = defineProps({
  title: {
    type: String,
    required: true,
    default: '',
  },
  date: {
    type: String,
    default: '',
  },
  readingTime: {
    type: Number,
    default: 0,
  },
  socialIcons: {
    type: Array as () => string[],
    default: () => ['twitter', 'facebook', 'linkedin', 'telegram', 'link'],
  },
})

const { share } = useShare()

const handleShare = (platform: string) => {
  if (platform === 'link') {
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  }

  share(platform, props.title)
}

const { locale } = useI18n()

const formattedDate = computed(() => {
  if (!props.date) return ''
  const isEn = locale.value && locale.value.startsWith('en')
  const loc = isEn ? 'en-US' : 'tr-TR'
  const dt = new Date(props.date)

  // Force Month Day, Year order for detail pages regardless of locale
  const monthStr = new Intl.DateTimeFormat(loc, { month: 'long' }).format(dt)
  const dayStr = new Intl.DateTimeFormat(loc, { day: 'numeric' }).format(dt)
  const yearStr = new Intl.DateTimeFormat(loc, { year: 'numeric' }).format(dt)
  return `${monthStr} ${dayStr}, ${yearStr}`
})
</script>
